module.exports = __webpack_public_path__ + "img/mainmenbuttonRH.5615ed62.png";